module.exports = __webpack_public_path__ + "static/media/discontrol020.45058371.jpg";